import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { UserIcon } from '@heroicons/react/20/solid';
import { CellContext } from '@tanstack/react-table';

import { pluralize } from '../../utilities/pluralize';

import { TableRosterRoomAssignment } from '.';

const RoomInfo = ({
  info,
}: {
  info: CellContext<TableRosterRoomAssignment, string>;
}) => {
  const roomNumber = info.getValue();
  const bedNumber = info.row.original.bedNumber;
  const roomBeds = info.row.original.roomBeds;
  const { roommates } = info.row.original;
  let rowText: string;

  // no need to show the bed number if this is a single room
  if (roomBeds < 2 && bedNumber < 2) {
    rowText = roomNumber;
  } else {
    rowText = `${roomNumber}-${bedNumber.toString().padStart(2, '0')}`;
  }

  if (roommates?.length && roommates?.length > 1) {
    return (
      <Popover>
        <PopoverButton className="block w-full data-[focus]:outline-1 focus:outline-none">
          <div className="flex items-center justify-between">
            <span className="flex">{rowText}</span>
            {roommates?.length && roommates?.length > 1 ? (
              <span className="flex items-center gap-0.5">
                +{roommates.length - 1} <UserIcon className="size-4" />
              </span>
            ) : null}
          </div>
        </PopoverButton>
        <PopoverPanel
          transition
          anchor="bottom start"
          className="rounded-md bg-white text-sm/6 shadow transition duration-200 ease-in-out [--anchor-gap:var(--spacing-5)] data-[closed]:-translate-y-1 data-[closed]:opacity-0"
        >
          <div className="flex flex-col gap-2 px-4 py-2.5">
            <div className="text-primaryGray">
              Room {roomNumber} - {roommates?.length}{' '}
              {pluralize(roommates?.length ?? 0, 'Guest')}
            </div>
            <ul className="flex flex-col gap-2">
              {roommates?.map((roommate, i) => {
                return (
                  <li key={i} className="text-secondaryBlue">
                    &bull;{' '}
                    <span>
                      {roommate?.lastName}, {roommate?.firstName}
                      {roommate?.semiUniqueIdentifier
                        ? ` (${roommate?.semiUniqueIdentifier})`
                        : ''}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </PopoverPanel>
      </Popover>
    );
  }

  return rowText;
};

export default RoomInfo;
